/**
 * @module support/shared/widgets
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

import { Injectable } from '@angular/core';
import { StateStoreUtilsService } from '@support/state-object-hash-utilities/utils/state-store-utils.service';
// import {CHANNELS, SETTINGS} from '@environment/settings';

// @TODO use matchmedia instead
@Injectable()
export class UIPermissionService {
  constructor(private stateStoreUtilsService: StateStoreUtilsService) {}
  /**
   * Check whether single permission is enabled
   * @returns boolean
   */
  // TODO: Need to update it to accept multiple parameters
  public checkPermissions(url: string, permissionName: string, permissionType?: string): boolean {
    const hasPermission = this.stateStoreUtilsService.getPermissionABFValue(url, permissionName);
    let isPermissionEnabled: boolean;
    if (permissionType === 'RepOnly') {
      isPermissionEnabled = true;
    } else {
      isPermissionEnabled = hasPermission && hasPermission.toUpperCase() === 'ENABLE';
    }
    return isPermissionEnabled;
  }
  /**
   * Check whether multiple permissions are enabled
   * @returns boolean
   */
  public checkMultiplePermissions(
    url: string,
    firstPermission: string,
    secondPermission: string,
    permissionType1?: string,
    permissionType2?: string
  ): boolean {
    return (
      this.checkPermissions(url, firstPermission, permissionType1) &&
      this.checkPermissions(url, secondPermission, permissionType2)
    );
  }
}
